import { render, staticRenderFns } from "./add-product.vue?vue&type=template&id=3ca71f7d&scoped=true"
import script from "./add-product.vue?vue&type=script&lang=js"
export * from "./add-product.vue?vue&type=script&lang=js"
import style0 from "./add-product.vue?vue&type=style&index=0&id=3ca71f7d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca71f7d",
  null
  
)

export default component.exports